const SAFE_PAGE = /^[a-z][a-z0-9_-]{0,40}$/;
const SAFE_SECTION = /^[a-z][a-z0-9_-]{0,40}$/;
export function parseRoute(hash = globalThis.location?.hash || '') {
  const raw = String(hash || '').replace(/^#/, '');
  const [path, query = ''] = raw.split('?');
  const page = SAFE_PAGE.test(path) ? path : 'dashboard';
  const params = new URLSearchParams(query);
  const sectionValue = String(params.get('section') || '');
  const section = SAFE_SECTION.test(sectionValue) ? sectionValue : '';
  const recordId = Number(params.get('id') || 0);
  const returnToValue = String(params.get('back') || '');
  const returnTo = SAFE_PAGE.test(returnToValue) ? returnToValue : '';
  return { page, section, recordId: Number.isSafeInteger(recordId) && recordId > 0 ? recordId : null, returnTo };
}
export function formatRoute({ page = 'dashboard', section = '', recordId = null, returnTo = '' } = {}) {
  const safePage = SAFE_PAGE.test(String(page)) ? String(page) : 'dashboard';
  const params = new URLSearchParams();
  if (SAFE_SECTION.test(String(section))) params.set('section', String(section));
  if (Number.isSafeInteger(Number(recordId)) && Number(recordId) > 0) params.set('id', String(Number(recordId)));
  if (SAFE_PAGE.test(String(returnTo)) && String(returnTo) !== safePage) params.set('back', String(returnTo));
  return `#${safePage}${params.toString() ? `?${params}` : ''}`;
}
